// extracted by mini-css-extract-plugin
export default {"Barcode":"barcode-module_Barcode_JcqoA"};